import {GridColumnsResponseModel} from "../../../../../models";

export const ColumnsCacheService = (() => {
    // Single cache for all column configurations
    const cache = new Map();

    return {
        // Get columns from cache
        getColumns: (userId:number, gridId:number) => {
            const key = `${userId}_${gridId}`;
            return cache.get(key);
        },

        // Set columns in cache
        setColumns: (userId:number, gridId:number, columns:GridColumnsResponseModel[]) => {
            const key = `${userId}_${gridId}`;
            cache.set(key, columns);
        },

        // Check if columns exist in cache
        hasColumns: (userId:number, gridId:number) => {
            const key = `${userId}_${gridId}`;
            return cache.has(key);
        },

        // Clear specific columns from cache
        clearColumns: (userId:number, gridId:number) => {
            const key = `${userId}_${gridId}`;
            cache.delete(key);
        },

        // Clear all cache
        clearAll: () => {
            cache.clear();
        }
    };
})();